function brandTemplateRequest(opts) {
  return {
    type: 'API_REQUEST',
    service: 'BRAND_TEMPLATES',
    ...opts
  };
}

export function getBrandHeader(slug) {
  return brandTemplateRequest({
    path: `${slug}-header.html`,
    handleResponse: res => res.text,
    handleError: () => null
  });
}

export function getBrandFooter(slug) {
  return brandTemplateRequest({
    path: `${slug}-footer.html`,
    handleResponse: res => res.text,
    handleError: () => null
  });
}
